<template>
  <div class="monitor flex_bc">
    <div class="left">
      <cus-border title="监控展示">
        <monitor-page ref="monitor" :M_list="lists" v-if="showMonitor" />
      </cus-border>
    </div>
    <div class="right">
      <cus-border title="设备列表">
        <right-list ref="monitorlist" :M_list="lists" @childCode="childCode" />
      </cus-border>
    </div>
  </div>
</template>
<script>
  import monitorPage from './components/monitorPage.vue'
  import rightList from './components/list.vue'
  import { getVideoList } from '@/api/video'
  export default {
    name: 'monitor',
    components: { monitorPage, rightList },
    data() {
      return {
        tagCheck: 0,
        showMonitor: false,
        lists: [
          // {
          //   name: '90cc4a248f084ed081e7ceea2cf5777b',
          //   title: '巩留旅游库尔德宁监控',
          //   site: 1,
          //   id: 1,
          // },
          // {
          //   name: 'a69ca5aaf42d4ad29d6608f72bb471c7',
          //   title: '安居尔花苑生活区',
          //   site: 1,
          //   id: 2,
          // },
          // {
          //   name: '0188f20058994971ad050fd3f6d7f1da',
          //   title: '伊宁市贝语新城售楼中心VIP室',
          //   site: 1,
          //   id: 1,
          // },
          // {
          //   name: '288a464800bd4f0baf17d57cd73ec1f7',
          //   title: '伊宁市贝语新城售楼中心东南角',
          //   site: 1,
          //   id: 2,
          // },
          // {
          //   name: '7846e240cfad44edb530ef34f7aa20c4',
          //   title: '伊宁市贝语新城售楼中心西北角',
          //   site: 1,
          //   id: 3,
          // },
          // {
          //   name: 'ae61fa794dc941d5ab998fd3361e8805',
          //   title: '伊宁市恒大绿洲四期14#15#大门',
          //   site: 1,
          //   id: 4,
          // },
          // {
          //   name: 'c452eaed40ac4620836cd144b05169a8',
          //   title: '伊宁市恒大绿洲四期14#15#大门外',
          //   site: 1,
          //   id: 5,
          // },
        ], //监控点列表------模拟数据，后期通过接口打通
      }
    },
    created() {
      this.getMonitorList()
    },
    mounted() {
      this.loginA()
    },
    methods: {
      childCode(code) {
        this.$refs.monitor.checkliItem(code)
      },
      getMonitorList() {
        getVideoList({ scenic_spot_id: 45, page: 1, limit: 40 }).then((res) => {
          const { data } = res
          this.list = data.rows
          this.$nextTick(() => {
            this.$refs.monitorlist.setList(data.rows)
          })
        })
      },
      handleTag(item, index) {
        this.tagCheck = index
      },
      loginA() {
        let anime = this.$animejs
        // form 动效card
        anime({
          targets: '.left',
          translateX: [-600, 0],
          easing: 'easeInOutSine',
        })
        anime({
          targets: '.right',
          translateX: [600, 0],
          easing: 'easeInOutSine',
        })
        // 卡片
        // anime({
        //   targets: ['.left', '.right'],
        //   scale: [0, 1],
        //   duration: 2000,
        // })

        setTimeout(() => {
          this.showMonitor = true
        }, 1000)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .monitor {
    height: 100%;
    width: 100%;
    text-align: left;
    position: relative;
    z-index: 3;
    .left {
      flex: 1;
    }
    .right {
      width: 30%;
      margin-left: 20px;
    }
  }
</style>
